<script setup lang="ts">
defineProps<{ rating: number }>();
</script>

<template>
  <div class="flex items-center gap-0.5">
    <span v-for="i in 5" :key="i" class="i-local-star size-4" :class="i <= rating ? 'fill-primary': 'fill-light'" />
  </div>
</template>
